export default {
  'ticket.operator': 'Operator',
  'ticket.status': 'Status',
  'ticket.lastupdate': 'Letzte Aktualisierung',
  'ticket.ticketid': 'Ticketnummer',
  'ticket.subject': 'Thema',
  'ticket.total': 'Summe der Flugtickets',
  'ticket.notassigned': 'Nicht zugeordnet',
  'ticket.addnewticket': 'Neues Flugticket',
  'ticket.search': 'suchen',
  'ticket.myticket': 'Mein Flugticket',
  'ticket.knowleadgebase': 'Wissensbasis',
  'ticket.announcements': 'Ankündigungen',
  'ticket.description': 'Beschreibung',
  'ticket.mytickets': 'Meine Flugtickets',
  'ticket.knowledgebase': 'Wissensbasis',
  'ticket.all': 'Alle',
  'ticket.done': 'Abgemacht !/ Fertig !',
  'ticket.inprogress': 'In Bearbeitung',
  'ticket.new': 'Neu',
  'ticket.ticketsInbox': 'Inbox',
  'ticket.ticketsUnread': 'ungelesen',
  'ticket.sender': 'Sender',
  'ticket.findtickets': 'Flugtickets suchen',
  'ticket.newticket': 'Neues Flugticket',
  'ticket.startTravelDate': 'Reisedatum von',
  'ticket.endTravelDate': 'Datum der Reise nach',
  'ticket.send': 'senden',
  'ticket.close': 'schließen',
  'ticket.text': 'Text',
  'ticket.insertSubject': 'Bitte geben Sie den Betreff Ihrer Anfrage ein',
  'ticket.insertText': 'Bitte geben Sie den Text Ihrer Anfrage ein',
  'ticket.insertMessageAndSubject':
    'Bitte geben Sie den Betreff und den Text Ihrer Anfrage ein',
  'ticket.details': 'Einzelheiten',
  'ticket.reply': 'Antwort',
  'ticket.dateoforder': 'Datum der Bestellung',
  'ticket.dateoftravel': 'Reisedatum',
  'ticket.item': 'Artikel',
  'ticket.submitinwriting': 'Schriftlich einreichen',
  'ticket.attachphoto':
    'In diesem Teil des Anfragebereichs können Sie über den untenstehenden Link Ihr gewünschtes Foto hochladen.',
};
